export const LogoMark = ({ className = "h-10 w-auto" }) => (
  <img src="/img/logo-lf-mark.png" alt="" aria-hidden="true" className={className} />
);

export const LogoFull = ({ className = "h-40 w-auto" }) => (
  <img src="/img/logo-lf-full.png" alt="Lunghe Frequenze" className={className} />
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-9 w-auto" />
    <span className={`whitespace-nowrap text-[13px] font-normal uppercase tracking-[0.04em] max-[420px]:hidden sm:text-[15px] ${light ? "text-[#FBF9F5]" : "text-[#1C1917]"}`}>
      Lunghe Frequenze APS
    </span>
  </span>
);
